var Vendd = (function (Vendd) {
    'use strict';

    Vendd.UserSelect = (function (UserSelect) {

        UserSelect.Messages = (function (Messages) {
            // ==========================================================================
            // SUBMIT SET INTERFACE USER
            // ==========================================================================
            Messages.SubmitSetInterfaceUser = function (model) {
                var data = {
                    model: model
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserSelect.Messages.SubmitSetInterfaceUser', data);
            };
            Messages.SubmitSetInterfaceUser.className = 'Vendd.UserSelect.Messages.SubmitSetInterfaceUser';

            Messages.SubmitSetInterfaceUserSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserSelect.Messages.SubmitSetInterfaceUserSuccess', response);
            };
            Messages.SubmitSetInterfaceUserSuccess.className = 'Vendd.UserSelect.Messages.SubmitSetInterfaceUserSuccess';

            Messages.SubmitSetInterfaceUserFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserSelect.Messages.SubmitSetInterfaceUserFailure', response);
            };
            Messages.SubmitSetInterfaceUserFailure.className = 'Vendd.UserSelect.Messages.SubmitSetInterfaceUserFailure';

            // ==========================================================================
            // SUBMIT CLEAR INTERFACE USER
            // ==========================================================================
            Messages.ClearInterfaceUser = function (model) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserSelect.Messages.ClearInterfaceUser');
            };
            Messages.ClearInterfaceUser.className = 'Vendd.UserSelect.Messages.ClearInterfaceUser';

            Messages.ClearInterfaceUserSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserSelect.Messages.ClearInterfaceUserSuccess', response);
            };
            Messages.ClearInterfaceUserSuccess.className = 'Vendd.UserSelect.Messages.ClearInterfaceUserSuccess';

            Messages.ClearInterfaceUserFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserSelect.Messages.ClearInterfaceUserFailure', response);
            };
            Messages.ClearInterfaceUserFailure.className = 'Vendd.UserSelect.Messages.ClearInterfaceUserFailure';

            // ==========================================================================
            // SEARCH USERS
            // ==========================================================================
            Messages.SearchUsers = function (model) {
                var data = {
                    model: model
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserSelect.Messages.SearchUsers', data);
            };
            Messages.SearchUsers.className = 'Vendd.UserSelect.Messages.SearchUsers';

            Messages.SearchUsersSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserSelect.Messages.SearchUsersSuccess', response);
            };
            Messages.SearchUsersSuccess.className = 'Vendd.UserSelect.Messages.SearchUsersSuccess';

            Messages.SearchUsersFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserSelect.Messages.SearchUsersFailure', response);
            };
            Messages.SearchUsersFailure.className = 'Vendd.UserSelect.Messages.SearchUsersFailure';


            // ==========================================================================
            // SUBMIT SET INTERFACE USER FROM INLINE ADMIN
            // ==========================================================================
            Messages.SubmitSetInterfaceUserInlineAdmin = function (model) {

                var data = {
                    model: model
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserSelect.Messages.SubmitSetInterfaceUserInlineAdmin', data);
            };
            Messages.SubmitSetInterfaceUserInlineAdmin.className = 'Vendd.UserSelect.Messages.SubmitSetInterfaceUserInlineAdmin';

            Messages.SubmitSetInterfaceUserInlineAdminSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserSelect.Messages.SubmitSetInterfaceUserInlineAdminSuccess', response);
            };
            Messages.SubmitSetInterfaceUserInlineAdminSuccess.className = 'Vendd.UserSelect.Messages.SubmitSetInterfaceUserInlineAdminSuccess';

            Messages.SubmitSetInterfaceUserInlineAdminFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserSelect.Messages.SubmitSetInterfaceUserInlineAdminFailure', response);
            };
            Messages.SubmitSetInterfaceUserInlineAdminFailure.className = 'Vendd.UserSelect.Messages.SubmitSetInterfaceUserInlineAdminFailure';

            return Messages;

        })(UserSelect.Messages || {});

        return UserSelect;

    })(Vendd.UserSelect || {});

    return Vendd;

})(Vendd || {});